export class Analyse {
    test_equi = 0;
    test_tronc = 0;
    test_sou_epa = 0;
    test_debout = 0;
    imc = 0;
    test_dijon = 0;
    resultatFinal;
    niveau;
    niveauChiffre;
    constructor(array){
        if (localStorage.user !== undefined){
            var user = JSON.parse(localStorage.user);
            for (let attribut in array) {
                if (attribut == 'testEquilibre'){
                    let resultat = array[attribut];
                    resultat = 60 - resultat;
                    if ( user.age == '20-30' || user.age == '-19'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 31){
                                this.test_equi = 5;
                            }else if (resultat >= 27 && resultat <= 30){
                                this.test_equi = 4;
                            }else if (resultat >= 21 && resultat <= 26){
                                this.test_equi = 3;
                            }else if (resultat >= 17 && resultat <= 20){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }else{
                            if (resultat >= 27){
                                this.test_equi = 5;
                            }else if (resultat >= 24 && resultat <= 26){
                                this.test_equi = 4;
                            }else if (resultat >= 18 && resultat <= 23){
                                this.test_equi = 3;
                            }else if (resultat >= 15 && resultat <= 17){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }
                    }else if (user.age == '30-40'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 28){
                                this.test_equi = 5;
                            }else if (resultat >= 24 && resultat <= 27){
                                this.test_equi = 4;
                            }else if (resultat >= 18 && resultat <= 23){
                                this.test_equi = 3;
                            }else if (resultat >= 17 && resultat <= 17){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }else{
                            if (resultat >= 23){
                                this.test_equi = 5;
                            }else if (resultat >= 19 && resultat <= 23){
                                this.test_equi = 4;
                            }else if (resultat >= 15 && resultat <= 18){
                                this.test_equi = 3;
                            }else if (resultat >= 12 && resultat <= 14){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }
                    }else if (user.age == '40-50'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 24){
                                this.test_equi = 5;
                            }else if (resultat >= 20 && resultat <= 23){
                                this.test_equi = 4;
                            }else if (resultat >= 12 && resultat <= 19){
                                this.test_equi = 3;
                            }else if (resultat >= 8 && resultat <= 11){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }else{
                            if (resultat >= 20){
                                this.test_equi = 5;
                            }else if (resultat >= 16 && resultat <= 19){
                                this.test_equi = 4;
                            }else if (resultat >= 10 && resultat <= 15){
                                this.test_equi = 3;
                            }else if (resultat >= 7 && resultat <= 9){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }
                    }/*else if (user.age == '51-60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 18){
                                this.test_equi = 5;
                            }else if (resultat >= 14 && resultat <= 17){
                                this.test_equi = 4;
                            }else if (resultat >= 10 && resultat <= 13){
                                this.test_equi = 3;
                            }else if (resultat >= 6 && resultat <= 9){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }else{
                            if (resultat >= 16){
                                this.test_equi = 5;
                            }else if (resultat >= 12 && resultat <= 15){
                                this.test_equi = 4;
                            }else if (resultat >= 8 && resultat <= 11){
                                this.test_equi = 3;
                            }else if (resultat >= 5 && resultat <= 7){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }
                    }*/
                    else if (user.age == '+60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 14){
                                this.test_equi = 5;
                            }else if (resultat >= 10 && resultat <= 13){
                                this.test_equi = 4;
                            }else if (resultat >= 6 && resultat <= 9){
                                this.test_equi = 3;
                            }else if (resultat >= 3 && resultat <= 5){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }else{
                            if (resultat >= 14){
                                this.test_equi = 5;
                            }else if (resultat >= 10 && resultat <= 13){
                                this.test_equi = 4;
                            }else if (resultat >= 6 && resultat <= 9){
                                this.test_equi = 3;
                            }else if (resultat >= 3 && resultat <= 5){
                                this.test_equi = 2;
                            }else{
                                this.test_equi = 1;
                            }
                        }
                    }

                    //fin test equi
                }else if (attribut == 'testSouplesseTronc'){
                    let resultat = array[attribut];
                    if(user.sexe == 'homme'){
                        if (resultat >= 4){
                            this.test_tronc = 5;
                        }else if (resultat == 3){
                            this.test_tronc = 4;
                        }else if (resultat ==2){
                            this.test_tronc = 3;
                        }else if (resultat == 1){
                            this.test_tronc = 2;
                        }else{
                            this.test_tronc = 1;
                        }
                    }else{
                        this.test_tronc = resultat;
                    }
                }else if (attribut == 'testSouplesseEpaules'){
                    let resultat = array[attribut];
                    this.test_sou_epa = resultat;


                }else if (attribut == 'testAssisDebout'){
                    let resultat = array[attribut];

                    if ( user.age == '20-30' || user.age == '-19'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 34){
                                this.test_debout = 5;
                            }else if (resultat == 33){
                                this.test_debout = 4;
                            }else if (resultat >= 31 && resultat <= 32){
                                this.test_debout = 3;
                            }else if (resultat >= 21 && resultat <= 30){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }else{
                            if (resultat >= 34){
                                this.test_debout = 5;
                            }else if (resultat >= 32 && resultat <= 33){
                                this.test_debout = 4;
                            }else if (resultat >= 27 && resultat <= 30){
                                this.test_debout = 3;
                            }else if (resultat >= 21 && resultat <= 26){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }
                    }else if (user.age == '30-40'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 33){
                                this.test_debout = 5;
                            }else if (resultat >= 30 && resultat <= 32){
                                this.test_debout = 4;
                            }else if (resultat >= 25 && resultat <= 29){
                                this.test_debout = 3;
                            }else if (resultat >= 19 && resultat <= 24){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }else{
                            if (resultat >= 27){
                                this.test_debout = 5;
                            }else if (resultat >= 21 && resultat <= 26){
                                this.test_debout = 4;
                            }else if (resultat >= 19 && resultat <= 20){
                                this.test_debout = 3;
                            }else if (resultat >= 17 && resultat <= 18){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }
                    }else if (user.age == '40-50'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 25){
                                this.test_debout = 5;
                            }else if (resultat >= 20 && resultat <= 24){
                                this.test_debout = 4;
                            }else if (resultat == 19){
                                this.test_debout = 3;
                            }else if (resultat >= 17 && resultat <= 18){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }else{
                            if (resultat >= 27){
                                this.test_debout = 5;
                            }else if (resultat >= 22 && resultat <= 26){
                                this.test_debout = 4;
                            }else if (resultat >= 18 && resultat <= 21){
                                this.test_debout = 3;
                            }else if (resultat >= 16 && resultat <= 17){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }
                    }/*else if (user.age == '51-60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 21){
                                this.test_debout = 5;
                            }else if (resultat >= 18 && resultat <= 20){
                                this.test_debout = 4;
                            }else if (resultat >= 16 && resultat <= 17){
                                this.test_debout = 3;
                            }else if (resultat >= 14 && resultat <= 15){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }else{
                            if (resultat >= 18){
                                this.test_debout = 5;
                            }else if (resultat >= 16 && resultat <= 117){
                                this.test_debout = 4;
                            }else if (resultat >= 14 && resultat <= 15){
                                this.test_debout = 3;
                            }else if (resultat >= 12 && resultat <= 13){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }
                    }*/
                    else if (user.age == '+60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 19){
                                this.test_debout = 5;
                            }else if (resultat >= 17 && resultat <= 18){
                                this.test_debout = 4;
                            }else if (resultat >= 15 && resultat <= 16){
                                this.test_debout = 3;
                            }else if (resultat >= 13 && resultat <= 14){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }else{
                            if (resultat >= 17){
                                this.test_debout = 5;
                            }else if (resultat >= 15 && resultat <= 17){
                                this.test_debout = 4;
                            }else if (resultat >= 13 && resultat <= 15){
                                this.test_debout = 3;
                            }else if (resultat >= 11 && resultat <= 13){
                                this.test_debout = 2;
                            }else{
                                this.test_debout = 1;
                            }
                        }
                    }

                    //fin test debout
                }else if (attribut == 'imc'){
                    let resultat = array[attribut];

                    if ( user.age == '-19'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 24){
                                this.imc = 1;
                            }else if (resultat > 22 && resultat <= 23){
                                this.imc = 2;
                            }else if (resultat > 21 && resultat <= 22){
                                this.imc = 3;
                            }else if (resultat > 20 && resultat <= 21){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 24){
                                this.imc = 1;
                            }else if (resultat > 22 && resultat <= 23){
                                this.imc = 2;
                            }else if (resultat > 20 && resultat <= 22){
                                this.imc = 3;
                            }else if (resultat > 19 && resultat <= 20){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }else if (user.age == '20-30'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 27){
                                this.imc = 1;
                            }else if (resultat > 25 && resultat <= 26){
                                this.imc = 2;
                            }else if (resultat > 23 && resultat <= 25){
                                this.imc = 3;
                            }else if (resultat > 21 && resultat <= 23){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 24){
                                this.imc = 1;
                            }else if (resultat > 22 && resultat <= 23){
                                this.imc = 2;
                            }else if (resultat > 21 && resultat <= 22){
                                this.imc = 3;
                            }else if (resultat > 19 && resultat <= 21){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }else if (user.age == '30-40'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 28){
                                this.imc = 1;
                            }else if (resultat > 26 && resultat <= 27){
                                this.imc = 2;
                            }else if (resultat > 24 && resultat <= 26){
                                this.imc = 3;
                            }else if (resultat > 23 && resultat <= 24){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 26){
                                this.imc = 1;
                            }else if (resultat > 24 && resultat <= 25){
                                this.imc = 2;
                            }else if (resultat > 22 && resultat <= 24){
                                this.imc = 3;
                            }else if (resultat > 20 && resultat <= 22){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }else if (user.age == '40-50'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 29){
                                this.imc = 1;
                            }else if (resultat > 27 && resultat <= 28){
                                this.imc = 2;
                            }else if (resultat > 25 && resultat <= 27){
                                this.imc = 3;
                            }else if (resultat > 23 && resultat <= 25){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 28){
                                this.imc = 1;
                            }else if (resultat > 25 && resultat <= 27){
                                this.imc = 2;
                            }else if (resultat > 23 && resultat <= 25){
                                this.imc = 3;
                            }else if (resultat > 21 && resultat <= 23){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }/*else if (user.age == '51-60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 29){
                                this.imc = 1;
                            }else if (resultat > 27 && resultat <= 28){
                                this.imc = 2;
                            }else if (resultat > 25 && resultat <= 27){
                                this.imc = 3;
                            }else if (resultat > 24 && resultat <= 25){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 29){
                                this.imc = 1;
                            }else if (resultat > 26 && resultat <= 28){
                                this.imc = 2;
                            }else if (resultat > 24 && resultat <= 26){
                                this.imc = 3;
                            }else if (resultat > 22 && resultat <= 24){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }*/
                    else if (user.age == '+60'){
                        if(user.sexe == 'homme'){
                            if (resultat >= 29){
                                this.imc = 1;
                            }else if (resultat > 27 && resultat <= 28){
                                this.imc = 2;
                            }else if (resultat > 25 && resultat <= 27){
                                this.imc = 3;
                            }else if (resultat > 24 && resultat <= 25){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }else{
                            if (resultat >= 29){
                                this.imc = 1;
                            }else if (resultat > 26 && resultat <= 28){
                                this.imc = 2;
                            }else if (resultat > 24 && resultat <= 26){
                                this.imc = 3;
                            }else if (resultat > 22 && resultat <= 24){
                                this.imc = 4;
                            }else{
                                this.imc = 5;
                            }
                        }
                    }

                    //fin imc
                }else if(attribut == 'testDijon'){
                    let resultat = array[attribut];
                    if (resultat <= 30 && resultat > 25){
                        this.test_dijon = 5;
                    }else if (resultat >= 21 && resultat <= 25){
                        this.test_dijon = 4;
                    }else if (resultat > 15 && resultat <= 20){
                        this.test_dijon = 3;
                    }else if (resultat >= 11 && resultat <= 15){
                        this.test_dijon = 2;
                    }else{
                        this.test_dijon = 1;
                    }
                }
            }

            this.resultatFinal = this.test_equi *4 + this.test_tronc *4 + this.test_sou_epa*4 + this.test_debout*4 + this.imc *4 + this.test_dijon *4;
            
            if (this.resultatFinal < 40){
                this.niveau = 'debutant';
                this.niveauChiffre = 0;
            }else if (this.resultatFinal > 41 && this.resultatFinal < 81){
                this.niveau = 'intermediaire';
                this.niveauChiffre = 1;
            }else{
                this.niveau = 'confirme';
                this.niveauChiffre = 2;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/controller/analyseResultat.js